import apiClient, { tokenStorage, userStorage } from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const authService = {
  login: async (email, password) => {
    const { data } = await apiClient.post(ENDPOINTS.login, { email, password });
    tokenStorage.set(data.access_token);
    if (data.user) userStorage.set(data.user);
    return data;
  },
  clientLogin: async (companyId, email, password) => {
    const { data } = await apiClient.post(ENDPOINTS.clientLogin(companyId), { email, password });
    tokenStorage.set(data.access_token);
    if (data.user) userStorage.set(data.user);
    return data;
  },
  logout: () => {
    tokenStorage.clear();
    userStorage.clear();
  },
  isAuthenticated: () => Boolean(tokenStorage.get()),
};
